import { Suspense, useEffect, useMemo } from 'react'
import { useParams, Navigate, useSearchParams } from 'react-router'
import { usePageConfig } from '@hooks/usePageConfig'
import { useAppDispatch } from 'universal-scripts'
import { resetQueryState } from 'src/store/slices/query'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import ErrorMessage from '@components/ErrorBoundary/ErrorMessage'
import Loader from '@components/Loader/Loader'
import BuilderHeader from './BuilderHeader/BuilderHeader'
import BuilderHeaderView from './BuilderHeader/BuilderHeaderView'
import EditLayout from './EditLayout'
import ExistingQueryGate from './ExistingQueryGate'
import ResponsiveShield from '@components/ResponsiveShield/ResponsiveShield'

import './QueryBuilder.css'

export default function QueryBuilder() {
  const { id } = useParams<{ id: string }>()
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const mode = searchParams.get('mode') === 'view' ? 'view' : 'edit'

  const headerContent = useMemo(() => {
    return (
      <ErrorBoundary errorComponent={ErrorMessage}>
        <Suspense fallback={<Loader mini />}>
          {mode === 'view' ? <BuilderHeaderView /> : <BuilderHeader />}
        </Suspense>
      </ErrorBoundary>
    )
  }, [mode])

  usePageConfig('query-builder', headerContent)

  useEffect(() => {
    return () => {
      dispatch(resetQueryState())
    }
  }, [dispatch])

  if (!id) return <Navigate to="/queries" replace />

  const isNewQuery = id === 'new'

  return (
    <>
      {isNewQuery ? (
        <EditLayout id={id} />
      ) : (
        <ErrorBoundary errorComponent={ErrorMessage}>
          <Suspense fallback={<Loader />}>
            <ExistingQueryGate id={id} />
          </Suspense>
        </ErrorBoundary>
      )}
      <ResponsiveShield />
    </>
  )
}
